<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="lectureScheduleSettings" (change)="lectureScheduleSettingsChange()" (submit)="lectureScheduleSettingsSubmit()">
        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{ "SCHEDULE_LECTURE_SLOTS" | translate | titlecase }}</h6>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "START_DATE" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="startDate">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="lectureScheduleSettings.controls.startDate.touched && lectureScheduleSettings.controls.startDate.invalid && lectureScheduleSettings.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "END_DATE" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="endDate">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="lectureScheduleSettings.controls.endDate.touched && lectureScheduleSettings.controls.endDate.invalid && lectureScheduleSettings.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "SCHEDULE_TIME_SLOT" | translate | titlecase }} ({{ "IN_MINUTES" | translate | titlecase }})</label>
                                <input type="number" class="form-control" formControlName="scheduleTimeSlot">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="lectureScheduleSettings.controls.scheduleTimeSlot.touched && lectureScheduleSettings.controls.scheduleTimeSlot.invalid && lectureScheduleSettings.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="border-bottom d-block font-bold mb-3">{{"WORKING_DAYS" | translate | titlecase }}</label>
                                <ng-multiselect-dropdown placeholder="{{'SELECT' | translate | titlecase }}"
                                    [settings]="dropdownSettings" [data]="workingDaysData" 
                                    [(ngModel)]="selectedWorkingDays"
                                    formControlName="workingDays"
                                    (onSelect)="onItemSelect($event)">
                                </ng-multiselect-dropdown>

                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="lectureScheduleSettings.controls.workingDays.touched && lectureScheduleSettings.controls.workingDays.invalid && lectureScheduleSettings.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "LECTURE_START_TIME" | translate | titlecase }}</label>
                                <input type="time" class="form-control" formControlName="lectureStartTime">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="lectureScheduleSettings.controls.lectureStartTime.touched && lectureScheduleSettings.controls.lectureStartTime.invalid && lectureScheduleSettings.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "MAX_LECTURES_PER_DAY" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="maxLecturesPerDay">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="lectureScheduleSettings.controls.maxLecturesPerDay.touched && lectureScheduleSettings.controls.maxLecturesPerDay.invalid && lectureScheduleSettings.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 d-flex flex-wrap justify-content-center justify-content-lg-end">
                        <button type="reset" class="btn btn-outline-secondary m-2 rounded-0">
                            {{ "RESET" | translate | titlecase }}</button>
                        <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                                class="fas fa"></i>
                            {{ "GENERATE_SCHEDULE" | translate | titlecase }}</button>
                        <app-loader [show]="creating"></app-loader>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>